// ====================================================
// COMEX SALE PROMOTIONS
// TV + CEILING FANS
// Offer Ends: 6 September 2026
// ====================================================

(() => {
  "use strict";


  // ====================================================
  // CURRENT PRODUCT HANDLE
  // ====================================================

  const prodHandle = location.pathname.split("/").pop();


  // ====================================================
  // PRODUCT GROUPS
  // ====================================================


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  const ceilingFanProducts = [
    "prism-oasis",
    "oasis-pro",
    "oasis-pro-macaron"
  ];


  // ----------------------------------------------------
  // TV - FREE RIPPLE SOUNDBAR
  // U Ultra + AL OLED
  // ----------------------------------------------------

  const FreeRipple = [
    "prism-u55-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-u65-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-u75-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-u86-ultra-qd-mini-led-4k-ai-google-tv",
    "prism-55al-google-tv",
    "prism-65al-google-tv"
  ];
  


  // ----------------------------------------------------
  // TV - FIXED MOUNT + SOUNDBAR UPSIZE
  // Q43U / Q55U / Q65U
  // U55 2026 / U65 2026
  // ----------------------------------------------------

  const FixedMount43to100 = [
    "q43u-2026",
    "q55u-2026",
    "q65u-2026",
    "u55-2026",
    "u65-2026"
  ];


  // ----------------------------------------------------
  // TV - TILT MOUNT + SOUNDBAR UPSIZE
  // Q75U / Q85U / Q100U
  // U75 2026 / U75
  // U86
  // ----------------------------------------------------

  const TiltedMount55to86 = [
    "q75u-2026",
    "q85u-2026",
    "prism-q100-ultra-qled-google-tv",
    "u75-2026",
    "u75-qled-mini-led-google",
    "prism-u86-qd-mini-led"
  ];


  // ----------------------------------------------------
  // TV - QE SERIES
  // Q43QE / Q55QE / Q65QE / Q75QE
  // ----------------------------------------------------

  const QESeries = [
    "q43qe-2026",
    "q55qe-2026",
    "q65qe-2026",
    "q75qe-2026",
    "s32-google-tv",
    "prism-s40-google-tv",
    "prism-s43-google-tv"
  ];

  


  // ====================================================
  // HELPER
  // ====================================================

  function createBanner(
    img,
    title,
    desc,
    extra = "",
    freeTag = "9.9 SALE"
  ) {

    const wrapper = document.createElement("div");

    wrapper.className = "free_gift_banner layout2";

    wrapper.innerHTML = `
      <div class="free-gift comex">

        <img src="${img}" alt="">

        <div class="info-wrapper">

          <div class="title-wrapper">
            <span class="free-tag">${freeTag}</span>
            <span class="title">${title}</span>
          </div>

          ${
            desc
              ? `<p class="description">${desc}</p>`
              : ""
          }

          ${
            extra
              ? `<span class="description red">${extra}</span>`
              : ""
          }

        </div>

      </div>
    `;

    return wrapper;
  }


  // ====================================================
  // BANNERS
  // ====================================================


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  function getCeilingFanWarrantyBanner() {

    return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CFs_Desktop_cd7a14f0-d8da-4b5b-9180-85c8e15f33f1.png?v=1780035893",
        "Warranty extended from 1 year to 4 years full warranty, all parts + labour",
        "For all Oasis Fan models",
        "Offer Ends 13 September"
    );

  }


  // ----------------------------------------------------
  // FREE RIPPLE SOUNDBAR
  // ----------------------------------------------------

  function getFreeRippleSoundbar() {

    return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/qd-soundbar-sale.png?v=1788778807",
        "Upsized Discount for Soundbar Bundles",
        "For All TV Models",
        "Offer Ends 14 September"
    );

  }


  // ----------------------------------------------------
  // FIXED MOUNT
  // ----------------------------------------------------

  function getFixedMount43to100() {

    return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/qd-soundbar-sale.png?v=1788778807",
        "Upsized Discount for Soundbar Bundles",
        "For All TV Models",
        "Offer Ends 14 September"
    );

  }


  // ----------------------------------------------------
  // TILT MOUNT
  // ----------------------------------------------------

  function getTiltedMount55to86() {

    return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/qd-soundbar-sale.png?v=1788778807",
        "Upsized Discount for Soundbar Bundles",
        "For All TV Models",
        "Offer Ends 14 September"
    );

  }


  // ----------------------------------------------------
  // QE SERIES
  // ----------------------------------------------------

  function getQESeriesBanner() {

    return createBanner(
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/qd-soundbar-sale.png?v=1788778807",
        "Upsized Discount for Soundbar Bundles",
        "Only for QE Series & S Series TV",
        "Offer Ends 14 September"
    );

  }


  // ====================================================
  // PROMOTION LOGIC
  // ====================================================

  let banner = null;


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  if (ceilingFanProducts.includes(prodHandle)) {

    //banner = getCeilingFanWarrantyBanner();


  // ----------------------------------------------------
  // TV - FREE RIPPLE
  // ----------------------------------------------------

  } else if (FreeRipple.includes(prodHandle)) {

    banner = getFreeRippleSoundbar();


  // ----------------------------------------------------
  // TV - FIXED MOUNT
  // ----------------------------------------------------

  } else if (FixedMount43to100.includes(prodHandle)) {

    banner = getFixedMount43to100();


  // ----------------------------------------------------
  // TV - TILT MOUNT
  // ----------------------------------------------------

  } else if (TiltedMount55to86.includes(prodHandle)) {

    banner = getTiltedMount55to86();


  // ----------------------------------------------------
  // TV - QE SERIES
  // ----------------------------------------------------

  } else if (QESeries.includes(prodHandle)) {

    banner = getQESeriesBanner();

  }


  // ====================================================
  // STOP IF NO PROMOTION
  // ====================================================

  if (!banner) return;


  // ====================================================
  // INJECT BANNER
  // ====================================================

  function inject() {

    const target =
      document.querySelector('[itemprop="offers"]') ||
      document.querySelector(".variant-selector") ||
      document.querySelector(".product-form");

    if (!target || !target.parentNode) {
      return;
    }

    target.parentNode.insertBefore(
      banner,
      target
    );

  }


  // ====================================================
  // DOM READY
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      inject
    );

  } else {

    inject();

  }


  // ====================================================
  // SPECIAL POSITIONING
  // 49AL / 49AL 240Hz
  // ====================================================

  $(function () {

    const allowedProducts = [
      "prism-49al-240hz-8662946447587",
      "prism-49al-8662946316515"
    ];

    const productId = $("body").attr("id");

    if (allowedProducts.includes(productId)) {

      $(".free_gift_banner").each(function () {

        if (!$(this).next(".cart-hdden").length) {

          $(this).insertAfter(".cart-hdden");

        }

      });

    }

  });

})();


/* end of pdp banners */

